import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find.js";
import React from 'react';
import { useTheme } from 'styled-components';
import { getFundsListPath } from '@finect/front-resources/Products';
import { getProfilePath } from '@finect/front-core/Profiles';
import { KPIs, KPI } from '../../Products';
import { Section } from '../../Section';
import { AssetsLabel } from '../../Products/Labels';
export var ManagementCompanyKPIs = function ManagementCompanyKPIs(_ref) {
  var productType = _ref.productType,
    managementCompany = _ref.managementCompany,
    groupPages = _ref.groupPages,
    profile = _ref.profile;
  var theme = useTheme();
  var categories = managementCompany.categories ? managementCompany.categories : [];
  var groupPublicPages = groupPages ? groupPages.filter(function (tab) {
    return tab.privacy === 'PUBLIC' && !tab.hidden;
  }) : [];
  var hasFunds = groupPublicPages.find(function (tab) {
    return tab.alias.toLowerCase() === 'fondos';
  });
  var hasPlans = groupPublicPages.find(function (tab) {
    return tab.alias.toLowerCase() === 'planes';
  });
  var hasETFs = groupPublicPages.find(function (tab) {
    return tab.alias.toLowerCase() === 'etfs';
  });
  var path = profile && profile.model ? getProfilePath(theme, profile.model) : {};
  return React.createElement(Section, {
    bottomMargin: true,
    title: "Datos clave"
  }, React.createElement(KPIs, null, hasFunds && path && React.createElement(KPI, {
    title: 'Fondos',
    subtitle: 'seleccionados',
    href: "".concat(path.url, "/fondos")
  }), hasPlans && path && React.createElement(KPI, {
    title: 'Planes',
    subtitle: 'seleccionados',
    href: "".concat(path.url, "/planes")
  }), hasETFs && path && React.createElement(KPI, {
    title: 'ETFs',
    subtitle: 'seleccionados',
    href: "".concat(path.url, "/etfs")
  }), React.createElement(KPI, {
    title: managementCompany.stats ? managementCompany.stats.funds : '-',
    subtitle: productType.shortPlural,
    href: getFundsListPath(theme, productType, {
      company: managementCompany.id
    })
  }), React.createElement(KPI, {
    title: managementCompany.stats ? React.createElement(AssetsLabel, {
      value: managementCompany.stats.assets || 0,
      scale: "million",
      decimals: 0
    }) : '-',
    subtitle: "Activos"
  }), React.createElement(KPI, {
    title: categories.length,
    subtitle: "Categor\xEDas"
  })));
};